import styled from "styled-components";
import { Table, DatePicker, Progress, Divider, Icon} from "antd";
import {
  CommonCard,
  DataHeading,
  DataValue,
  UnderlineLink,
  CommonTable,
  DisplayFlex,
  SecondaryButtonComponent,
  ParagraphAnchorTypeWithoutLink
} from "../../../../CommonComponents/commonStyles";

export const InvestmentOption = styled.h1`
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
  font-size: ${props => props.theme.fontSize.h4};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.h4};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.headingColor};
  @media only screen and (max-width: 990px) {
    font-size: ${props => props.theme.fontSize.h5};
    line-height: ${props => props.theme.lineHeight.h5};
  }
`;

export const UnderlyingFund = styled(UnderlineLink)`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.primary};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  color: ${props => props.theme.fontColors.primary};
  width: 170px;
  word-wrap: break-word;
  &:hover {
    color: ${props => props.theme.fontColors.primary};
  }
  @media only screen and (max-width: 990px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.secondary};
    width: 150px;
  }
`;

export const UnderlyingFundParagraph = styled(ParagraphAnchorTypeWithoutLink)`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  font-weight: ${props => props.theme.fontWeight.bold};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.h4};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  color:${props => props.theme.fontColors.headingColor} !important;
  @media only screen and (max-width: 990px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.secondary};
  }
`;

export const TableData = styled(DataHeading)`
  font-size: ${props => props.theme.fontSize.primary};
  font-weight: ${props => props.theme.fontWeight.normal};
`;

export const DivHeading = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  font-size: ${props => props.theme.fontSize.primary};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.primary};
  letter-spacing: 0.5px;
  color: ${props => props.theme.fontColors.textColor};
  padding-bottom: ${props => props.paddingBottom ? props.paddingBottom: "0px"}
  @media only screen and (max-width: 990px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.secondary};
  }
`;

export const DownloadIcon = styled.a`
  margin-left: 19px;
  color: ${props => props.theme.colors.black};
  :hover {
    color: ${props => props.theme.colors.black};
  }
`;

export const IconsPlace = styled.div`
  margin-left: 80px;
  display: flex;
`;

export const IconsPlaceNew = styled.div`
  text-align: right;
  > span > button {
    padding-right: 30px;
  }
  @media (max-width: 576px) {
    > span > button {
      padding-right: 5px;
    }
  }
  @media (max-width: 990px) {
    text-align: initial;
    transform: initial;
    margin-bottom: 20px;
  }
`;

export const IconPadding = styled.div`
  display: flex;
  justify-content: space-around;
  cursor: pointer;
  @media (max-width: 990px) {
    margin-left: 0px;
    margin-right: 26px;
  }
`;

export const ShowButton = styled(SecondaryButtonComponent)`
  width: 117px;
  font-family: ${props => props.theme.fontFamily.helveticaNeueMedium}!important;
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  font-size: ${props => props.theme.fontSize.secondary} !important;
  @media (max-width: 990px) {
    width: 117px;
  }
`;
/** ****** MOBILE ****** */
export const MobileCard = styled(CommonCard)`
  background-color: ${props =>
    props.cardIndex % 2 === 0 ? props.theme.colors.greyColor : props.theme.colors.white};
  border: initial;
  padding: 20px 10px 20px 20px;
  margin: 10px 5px 10px 5px;
  box-shadow: ${props =>
    props.activeCard ? "2px 0 15px 0px rgba(0, 0, 0, 0.2)" : "initial"};
  &:first-child {
    margin: 21px 5px 10px 5px;
  }
`;

export const ChartArea = styled.div`
  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    flex: 1;
  }
  width: 700px;
  > div:first-child {
    color: ${props => props.theme.fontColors.headingColor};
  }
  @media (max-width: 576px) {
    width: 300px;
  }
`;

export const DataHead = styled(DataValue)`
  margin-bottom: 0;
`;

export const Goal = styled(DataHeading)`
  width: 300px;
  @media (max-width: 576px) {
    width: 220px;
  }
`;

export const Benchmark = styled(DataHeading)`
  width: 200px;
  @media (max-width: 576px) {
    width: 180px;
  }
`;

export const Management = styled(DataHeading)`
  width: auto;  
  @media (max-width: 576px) {
    width: 140px;
  }
`

export const ProgressLabel = styled(DataHeading)`
  font-size: ${props => props.theme.fontSize.primary};
  margin-top: -5px;
`;

export const ProgressCircle = styled.div`
  margin: 5px 18px 24px 0px;
`;

export const ProgressLabelContainer = styled.div`
  margin-top: 18px;
  @media (max-width: 576px) {
    margin-left: 18px;
  }
`;

export const PoolDesc = styled.div`
  padding: 0 10px 20px 0;
`;

export const CashSquare = styled.div`
  width: 10px;
  height: 10px;
  background-color: ${props => props.color};
  margin-right: 8px;
`;

export const StockSquare = styled.div`
  width: 10px;
  height: 10px;
  background-color: ${props => props.theme.backgroundColor.layoutOrange};
  margin-right: 8px;
`;

export const ReportIcon = styled(Icon)`
  color: ${props => props.theme.border.unchecked};
`;

export const InvestmentTable = styled(CommonTable)`

  .ant-table-fixed-header .ant-table-scroll .ant-table-header{
    overflow: auto;    
  }

  .ant-table-column-sorters {
    display: flex;
    justify-content: flex-end !important;
  }  

  .ant-table-tbody > tr > td {
    overflow: hidden !important;    
  }

  .ant-table-tbody > tr.ant-table-row-level-0:first-child > td {
    border-top: 2px solid ${props => props.theme.border.tableBorder} !important;
  } 

  .ant-table-tbody > tr.ant-table-row-level-0:last-child > td {
    border-bottom: none !important;
  } 
  
  .ant-table-tbody > tr.highlight {
    background: ${props => props.theme.backgroundColor.lightGrey} !important;
  }

  .ant-table-thead > tr > th .ant-table-header-column .ant-table-column-sorters:hover::before {
    background: transparent;    
  }

  ////////////////////////////////////////////////Common
  .ant-table-thead
    > tr
    > th.ant-table-column-has-actions.ant-table-column-has-sorters,
  .ant-table-thead
    > tr
    > th.ant-table-column-has-actions.ant-table-column-has-filters {
    padding-right: 0px !important;
  }

  .ant-table-tbody > tr > td {
    padding: 15px 3px 15px 25px !important;
    @media (max-width: 990px) {
      padding: 7px 0px 15px 16px !important;
    }
  }
  ////////////////////////////////////////////////Main Table 

  .ant-table-row-level-0:nth-child(odd){
    background-color: ${props => props.theme.backgroundColor.layoutLight} !important;    
  }

  tr.ant-table-expanded-row {
    background: ${props => props.theme.backgroundColor.layoutLight} !important;
  }

  .ant-table-expanded-row tr[data-row-key]>td:nth-child(5) {
    width: 113px
  }

  .ant-table-expanded-row tr[data-row-key]>td:nth-child(6) {
    width: 100px
  }

  @-moz-document url-prefix() {
    .ant-table-tbody > .ant-table-row-level-0 >td:nth-child(5)> div{
      width: 91px;
      padding-left: 2px;
    }
    .ant-table-tbody > .ant-table-row-level-0 >td:nth-child(4)> div{
      width: 82px;
      padding-left: 5px;
    }
    .ant-table-expanded-row tr[data-row-key]>td:nth-child(6) {
      width: 100px
    }
    .ant-table-expanded-row tr[data-row-key] > td:first-child > a {
      width: 180px;
    }
  }

  .ant-table-expanded-row .ant-table-fixed-header .ant-table-scroll {
    border-style: none !important;
  }

  .ant-table-tbody > .ant-table-row-level-0 :first-child {
    display: flex;
    flex-direction: column-reverse;
  }
  .ant-table-tbody > .ant-table-row-level-0 :first-child>td :first-child {
    width: 260px;
  }

  .main .ant-table .ant-table-content .ant-table-scroll .ant-table-body {
    max-height: auto !important;
  }

  .ant-table-fixed-header {
    .ant-table-scroll {
      .ant-table-header {
        padding-bottom: ${props => props.theme.spacing.paddings.noPadding} !important;
        margin-bottom: -6px !important;
        background: ${props => props.theme.backgroundColor.layoutLight};
      }
      border-width: 0px 1px 1px 1px !important;      
      border-color: ${props => props.theme.border.primary} !important;
    }
  }

  th {
    background: #fff !important;
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    font-size: ${props => props.theme.fontSize.primary};    
    line-height: ${props => props.theme.lineHeight.primary};
    letter-spacing: ${props => props.theme.letterSpacing.normal};
    color: ${props => props.theme.fontColors.textColor} !important;
  }
  .ant-table-thead {
    vertical-align: bottom;
    tr {
      th {        
        .ant-table-header-column{
          height: 70px;
          display: flex;          
          align-items: center;
        }
        .ant-table-column-sorters {
          display: flex;
          flex-direction: row-reverse;
          justify-content: flex-end;
        }
        .ant-table-column-sorter {
          transform: translate(-14px, 4px);
          display: block;
        }
        border-bottom-width: 2px;
        border-bottom-style: solid;
        border-bottom-color: ${props => props.theme.border.primary};
      }
      .ant-table-column-title {        
        transform: translate(-10px, 0px);        
      }
      .ant-table-column-title > div {
        letter-spacing:${props => props.theme.letterSpacing.zero};
        color: ${props => props.theme.fontColors.headingColor}!important;
      }
      border-bottom-width: 2px;
      border-bottom-style: solid;
      border-bottom-color: ${props => props.theme.border.primary};
    }
  }

  ////////////////////////////////////////////////Expanded Table
  .expanded {
    margin-left: -16px;
    margin-top: -16px;
    width: 101.8%;
  }
  &&.investmentOptionTable .ant-table-tbody > tr.ant-table-row-level-0: hover {
    cursor: pointer;
  }
  &&.investmentOptionTable .ant-table-tbody .ant-table-row.expandedRow > td: hover {
    cursor: default !important;
  }
  &&.investmentOptionTable .iodClearTable .ant-table-tbody > tr.ant-table-row-level-0: hover {
    cursor: default !important;
  }  
  &&.investmentOptionTable .ant-table-tbody > tr.myInvestmentTableIOD: hover {
    cursor: default !important;
  }
`;

export const PIPWrapper = styled(DisplayFlex)`
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  & > * {
    padding-right: 125px;
    @media only screen and (max-width: 990px) {
      padding-right: 21px;
    }
    @media only screen and (max-width: 576px) {
      padding-right: 0px;
    }
  }

  @media only screen and (max-width: 576px) {
    width: 100%;
  }
`;

export const ClearTable = styled(Table)`
  &&& {
    a:hover {
      text-decoration: underline;
    }
  }
  .ant-table-tbody > tr > td {
    background-color: ${props => props.theme.colors.white} !important;
    border: none;
  }
  .ant-table-body {
    margin-left: -10px;
  }
  tr.expandedRow > td {
    border-top: none !important; // Important is required to override the parent style.
    border-bottom: none !important; // Important is required to override the parent style.
  }
`;

export const CustomHistoricDate = styled(DatePicker)`
  .anticon .anticon-close-circle {
    visibility: hidden;
  }

  @media only screen and (max-width: 576px) {
    & > .ant-calendar {
      margin-left: 20px;
      z-index: 1;
    }

    & .ant-calendar-picker-container {
      margin-left: 20px;
      z-index: 1;
    }
  }
`;

export const DataExportPrint = styled(DataValue)`
  margin: 0px 5px;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};  
  line-height: ${props => props.theme.lineHeight.primary};
  letter-spacing: ${props => props.theme.letterSpacing.zero}; 
  color: ${props => props.theme.colors.primaryColor} !important;
  text-decoration: underline;
  display: block;
  :hover {
    color: ${props => props.theme.colors.primaryColor} !important;
    text-decoration: underline;
  }
  @media only screen and (max-width: 990px) {
    font-size: ${props => props.theme.fontSize.primary};
    line-height: ${props => props.theme.lineHeight.primary};
  }
  @media only screen and (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.secondary};
  }
  a{
    color: ${props => props.theme.colors.primaryColor}
    letter-spacing: ${props => props.theme.letterSpacing.zero};
  }
`;

export const ProgressUpdated = styled(Progress)`
  &&& {
    .ant-progress-circle-trail {
      stroke: ${props => props.theme.backgroundColor.layoutOrange} !important;
    }
  }
`;

export const IODivider = styled(Divider)`
  .ant-divider-vertical {
    height: auto !important;
  }

  &&& {
    .ant-divider,
    .ant-divider-vertical {
      height: auto !important;
    }
  }
`;

export const UnderlyingContent = styled(UnderlineLink)`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size:  ${props => props.theme.fontSize.primary};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
`;

export const ShowPercentage = styled.span`
font-weight: bold;
`;

export const NAVCalendar = styled.span`
.ant-calendar-picker-input {
  font-size: ${props => props.theme.fontSize.primary};
}
`;

export const showMoreRightPlace = styled.div`
  padding-right: '30px';  
`;